import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import WizardStep from "../../../components/Wizard/WizardStep";
import WysiwygEditor, { TokenType } from "../../common2/Templating/WysiwygEditor";
import ErrorText from "./ErrorText";

type Props = {
    onCancel: () => void,
    onNext: (text: string) => void,
    onPrevious: (text: string) => void,
    prompt: string,
    contentType: string
}

const DetailsPrompt = ({ onPrevious, onNext, onCancel, prompt, contentType }: Props) => {
    const [value, setValue] = useState(prompt);
    const [error, setError] = useState(false);

    useEffect(() => {
        setValue(prompt);
    },[prompt])

    const handleNext = () => {            
        onNext(value);
    }

    const handlePrevious = () => {        
        onPrevious(value);
    }

    return (
        <WizardStep title={`Please enter more details about the ${contentType}`} onNext={handleNext} onPrevious={handlePrevious} onCancel={onCancel}>
            <Typography variant="body2">Please give as much information as you can about the {contentType}.</Typography>

            <ErrorText message={error ? 'Please enter a prompt' : undefined} />

            <Box sx={{ mt: 5 }}>
                <WysiwygEditor
                    height='60vh'
                    html={value}
                    onChange={setValue}
                    tokenType={TokenType.Lead}
                    textMode={false}
                    showToolbar={false}
                />
            </Box>
        </WizardStep>
    )
}

export default DetailsPrompt;